var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M858.7,1173a10,10,0,1,0,10.007,9.993A9.991,9.991,0,0,0,858.7,1173Zm5.44,6.85-5.923,8.005a1.625,1.625,0,0,1-1.249.645h-.027a1.552,1.552,0,0,1-1.236-.618l-3.2-4.056a1.339,1.339,0,0,1,2.109-1.652l2.3,2.915,5.077-6.837a1.345,1.345,0,0,1,1.88-.269A1.329,1.329,0,0,1,864.143,1179.85Z",
    transform: "translate(-848.71 -1173)",
    fill: "#cdb273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkIcon);
export default __webpack_public_path__ + "static/media/ok-icon.cb6b0cc51bff27d5e679d1e68581daa6.svg";
export { ForwardRef as ReactComponent };